import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const SafeMeAdminAuthContext = createContext(null);

export function SafeMeAdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=admin
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/safeme/admin/auth/me");
      setUser(data.admin);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/safeme/admin/auth/login", { email, password });
    setUser(data.admin);
    return data.admin;
  };

  const logout = async () => {
    try {
      await api.post("/safeme/admin/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(false);
  };

  return (
    <SafeMeAdminAuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </SafeMeAdminAuthContext.Provider>
  );
}

export function useSafeMeAdminAuth() {
  return useContext(SafeMeAdminAuthContext);
}

export { formatApiError };
